import { TrendingDown, TrendingUp } from "lucide-react";
import { useI18n } from "../../../i18n";
import { fmtMoney } from "../../../lib/format";

const Kpi = ({ label, value, sub, delta, testId }) => (
  <div className="rounded-2xl bg-white p-4 shadow-sm" data-testid={testId}>
    <p className="text-xs font-medium text-slate-500">{label}</p>
    <p className="mt-1 text-2xl font-bold tabular-nums text-navy">{value}</p>
    <div className="mt-1 flex items-center gap-2 text-xs text-slate-500">
      {delta != null && (
        <span className={`flex items-center gap-0.5 font-semibold ${delta >= 0 ? "text-brand" : "text-rose-600"}`} data-testid={`${testId}-delta`}>
          {delta >= 0 ? <TrendingUp className="h-3.5 w-3.5" /> : <TrendingDown className="h-3.5 w-3.5" />}{delta >= 0 ? "+" : ""}{delta.toLocaleString("el-GR", { maximumFractionDigits: 1 })}%
        </span>
      )}
      <span>{sub}</span>
    </div>
  </div>
);

const pct = (a, b) => (b ? ((a - b) / b) * 100 : null);

export const Kpis = ({ d }) => {
  const { t } = useI18n();
  const a = d.amounts_visible;
  const main = (x) => (a ? fmtMoney(x.value) : t("insights.boxes", { n: x.qty }));
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="insights-kpis">
      <Kpi testId="kpi-ytd" label={t("insights.ytd")} value={main(d.ytd)} delta={a ? pct(d.ytd.value, d.lytd.value) : pct(d.ytd.qty, d.lytd.qty)}
        sub={`${t("insights.lytd")}: ${main(d.lytd)}`} />
      <Kpi testId="kpi-period" label={t("insights.periodTotal")} value={main(d.period)} sub={t("insights.orders", { n: d.period.orders })} />
      {a && <Kpi testId="kpi-aov" label={t("insights.aov")} value={d.avg_order_value != null ? fmtMoney(d.avg_order_value) : "—"} />}
      <Kpi testId="kpi-opm" label={t("insights.opm")} value={d.orders_per_month.toLocaleString("el-GR", { maximumFractionDigits: 1 })} />
    </div>
  );
};

export const TopList = ({ rows, by, nameOf, testId }) => {
  const { t } = useI18n();
  return (
    <ol className="divide-y divide-slate-100" data-testid={testId}>
      {rows.map((r, i) => (
        <li key={r.key} className="flex items-center gap-3 py-2.5 text-sm">
          <span className={`grid h-7 w-7 shrink-0 place-items-center rounded-full text-xs font-bold ${i < 3 ? "bg-brand text-white" : "bg-slate-100 text-slate-500"}`}>{i + 1}</span>
          <div className="min-w-0 flex-1"><p className="truncate font-medium text-navy">{nameOf(r.key)}</p><p className="text-xs text-slate-500">{r.key}</p></div>
          <div className="text-right tabular-nums">
            <p className="font-semibold text-navy">{by === "value" ? fmtMoney(r.value) : t("insights.boxes", { n: r.qty })}</p>
            {r.value != null && by !== "value" && <p className="text-xs text-slate-500">{fmtMoney(r.value)}</p>}
            {by === "value" && <p className="text-xs text-slate-500">{t("insights.boxes", { n: r.qty })}</p>}
          </div>
        </li>
      ))}
    </ol>
  );
};
